// extracted by mini-css-extract-plugin
export default {"Footer":"footer_Footer_WIBdR","PrimaryButton":"footer_PrimaryButton_VOLVv","SecondaryButton":"footer_SecondaryButton_kfsus"};